/**
 * Praxismodul-Attendance field validation (OU-1f, Scope C7).
 *
 * Lives in `/shared` (CLAUDE.md §26) so the backend route layer (authoritative)
 * AND the `<PraxismodulRow>` frontend component validate against ONE schema.
 *
 * A Praxismodul attendance record is the supervisor's answer to "war der/die
 * SuS im Praxismodul anwesend?" — a boolean plus an optional free-text note.
 * Unlike the Assessment entry (OU-1e) there is no rating and no
 * mutually-exclusive field logic, so a plain Zod schema is enough — no separate
 * `normalize`/`validate` pair.
 */
import { z } from 'zod';
export const PRAXISMODUL_NOTE_MAX_LENGTH = 500;
export const praxismodulAttendanceUpsertSchema = z.object({
    present: z.boolean(),
    note: z.string().max(PRAXISMODUL_NOTE_MAX_LENGTH).nullable(),
});
//# sourceMappingURL=praxismodul-attendance-validation.js.map